export default {
    init() {
        $('#mobile-nav-trigger').on('click', function() {
            $(this).toggleClass('is-active');
            $('#mobile-nav').toggle();
            $('.header--rule').toggle();
            $('#logotype').toggle();
            $(".mobile-nav-container").toggleClass('is-active')
        });
    }
};
